import { UserClientData } from './userclient-data';

export class UserData {
    username?: string;
    userId?: string;
    userType?: string;
    authenticationMode?: string;
    canSignOperations?: string;
    zcliente?: string;
    mobilePhone?: string;
    channel?: string;           // NBP ou NBE
    clients?: UserClientData[];
    companyId?: string;
    companyName?: string;
    companyClientNumber?: string;
}

